const subscriptionRenewKeys = {
  // Dialog
  "subscription.renew.dialog.title": "Renew Subscription",
  "subscription.renew.dialog.description": "By confirming this action, your subscription will no longer be cancelled. Thank you for staying with us!",
  "subscription.renew.dialog.renewal-date": "The subscription will renew on {{date}}",
  "subscription.renew.dialog.terms": "By renewing your subscription, you agree to our",
  "subscription.renew.dialog.and": "and",

  // Alternative approach with placeholders
  "subscription.renew.dialog.terms.full": "By renewing your subscription, you agree to our {{termsLink}} and {{privacyLink}}",

  // Actions
  "subscription.renew.action.renew": "Renew Subscription",

  // Notifications
  "subscription.renew.notification.success.title": "Subscription Renewed",
  "subscription.renew.notification.success.message": "Your subscription has been successfully renewed. Thank you for staying with us!",
  "subscription.renew.notification.error.title": "Error Renewing Subscription",
  "subscription.renew.notification.error.message": "An error occurred while renewing your subscription. Please try again.",
};

export const subscriptionRenew = {
  ...subscriptionRenewKeys,
};
